import React from 'react'
import { Badge } from '../../../../components'
import * as colors from '../../../../assets/js/colors'

export const STATUS_CIOT = {
  gerado: { label: 'Gerado', color: colors.azul },
  pendente: { label: 'Aguardando ANTT', color: colors.laranja },
  declarado: { label: 'Declarado', color: colors.verde_success },
  recusado: { label: 'Recusado', color: colors.vermelho_hover },
  cancelado: { label: 'Cancelado', color: colors.gray },
  encerrado: { label: 'Encerrado', color: colors.violeta },
}

export const OPCOES_STATUS_CIOT = Object.keys(STATUS_CIOT).map(value => ({
  label: STATUS_CIOT[value].label,
  value,
}))

export const CIOT_LOTACAO = 1
export const CIOT_FRACIONADA = 2

export const TIPOS_OPERACAO_CIOT = [
  { label: 'Carga Lotação (1)', value: CIOT_LOTACAO },
  { label: 'Carga Fracionada (2)', value: CIOT_FRACIONADA },
]

export const TIPOS_CARGA_CIOT = [
  { label: 'Granel sólido (1)', value: 1 },
  { label: 'Granel líquido (2)', value: 2 },
  { label: 'Frigorificada ou aquecida (3)', value: 3 },
  { label: 'Conteinerizada (4)', value: 4 },
  { label: 'Carga geral (5)', value: 5 },
  { label: 'Neogranel (6)', value: 6 },
  { label: 'Perigosa - granel sólido (7)', value: 7 },
  { label: 'Perigosa - granel líquido (8)', value: 8 },
  { label: 'Perigosa - frigorificada ou aquecida (9)', value: 9 },
  { label: 'Perigosa - conteinerizada (10)', value: 10 },
  { label: 'Perigosa - carga geral (11)', value: 11 },
  { label: 'Carga granel pressurizada (12)', value: 12 },
]

export const PAGAMENTO_OUTROS = 5
export const PAGAMENTO_PIX = 6
export const PAGAMENTOS_BANCARIOS = [2, 3, 4]

export const TIPOS_PAGAMENTO_CIOT = [
  { label: 'Conta corrente (2)', value: 2 },
  { label: 'Conta poupança (3)', value: 3 },
  { label: 'Conta de pagamento (4)', value: 4 },
  { label: 'Outros (5)', value: PAGAMENTO_OUTROS },
  { label: 'Pix (6)', value: PAGAMENTO_PIX },
]

export const NOMES_TIPO_EMITENTE_MDFE = {
  1: 'Prestador de serviço de transporte (1)',
  2: 'Transportador de carga própria (2)',
  3: 'Prestador de serviço que emitirá CT-e posteriormente (3)',
}

export const STATUS_MDFE_VIGENTE = ['autorizado', 'processando_autorizacao']

export const NOMES_STATUS_MDFE = {
  autorizado: 'autorizado',
  processando_autorizacao: 'aguardando a SEFAZ',
  encerrado: 'encerrado',
  cancelado: 'cancelado',
  erro_autorizacao: 'com erro de autorização',
  denegado: 'denegado',
}

export function BadgeStatusCiot({ status }) {
  const info = STATUS_CIOT[status]
  return info ? <Badge color={info.color}>{info.label}</Badge> : null
}

// CNPJ alfanumérico (NT 2025.001): letras maiúsculas e dígitos
export function normalizarDocumento(valor) {
  return String(valor || '')
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, '')
    .slice(0, 14)
}

export function formatarDocumento(valor) {
  const doc = normalizarDocumento(valor)
  if (doc.length === 11) return doc.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
  if (doc.length === 14) return doc.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5')
  return doc
}

export function formatarPlaca(valor) {
  return String(valor || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 7)
}

export function codigoCompletoCiot(ciot) {
  return ciot && ciot.codigo_verificador ? `${ciot.numero}${ciot.codigo_verificador}` : ''
}

export function rotuloCiot(ciot) {
  return ciot.codigo_verificador ? `${ciot.numero}-${ciot.codigo_verificador}` : ciot.numero
}

export function dataIsoParaDate(valor) {
  if (!valor) return null
  const [ano, mes, dia] = String(valor).slice(0, 10).split('-').map(Number)
  return ano && mes && dia ? new Date(ano, mes - 1, dia) : null
}

export function dateParaDataIso(data) {
  if (!data) return null
  const mes = `${data.getMonth() + 1}`.padStart(2, '0')
  const dia = `${data.getDate()}`.padStart(2, '0')
  return `${data.getFullYear()}-${mes}-${dia}`
}

export function formatarDataIso(valor) {
  const data = dataIsoParaDate(valor)
  return data ? data.toLocaleDateString('pt-BR') : ''
}

export function formatarDataHora(valor) {
  if (!valor) return ''
  const data = new Date(valor)
  return Number.isNaN(data.getTime())
    ? ''
    : `${data.toLocaleDateString('pt-BR')} ${data.toLocaleTimeString('pt-BR').slice(0, 5)}`
}

export function formatarMoeda(valor) {
  const numero = Number(valor)
  return valor === null || valor === undefined || Number.isNaN(numero)
    ? ''
    : numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

// O ID da UF no sistema é o código IBGE, que são os dois primeiros dígitos do código do município
export function ufIdDoMunicipio(codigoMunicipio) {
  const codigo = Number(codigoMunicipio)
  return codigo ? Math.floor(codigo / 100000) : null
}

export function parseCiotsVinculados(valor) {
  if (!valor) return []
  if (Array.isArray(valor)) return valor.filter(Boolean)
  try {
    const lista = JSON.parse(valor)
    return Array.isArray(lista) ? lista.filter(item => item && item.id) : []
  } catch (error) {
    return []
  }
}

export const estiloAvisoCiot = {
  padding: '8px 12px',
  borderRadius: 3,
  background: '#FFF3CD',
  border: '1px solid #FFEEBA',
  color: '#856404',
  fontSize: '0.85rem',
}

export const estiloErroCiot = {
  padding: '8px 12px',
  borderRadius: 3,
  background: '#F8D7DA',
  border: '1px solid #F5C6CB',
  color: '#721C24',
  fontSize: '0.85rem',
}

export const estiloDicaCiot = { fontSize: '0.8rem', color: '#888' }
